import {
  ROUTES,
  DEMO_ROUTES,
  SELF_ONBOARDING_ROUTES,
  SITE_AUTHENTICATION_ROUTES,
} from "src/consts/routes";
import { createContext } from "react";
import { Theme } from "@emotion/react";
import { THEMES, ThemeName } from "./theme";
import { useEffect, useMemo, useState } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { useLocation, useSearchParams } from "react-router-dom";
import { SMART_CHARGING_ROUTES } from "src/consts/Paths/SmartCharging";

interface ThemeUsageProps {
  children: React.ReactNode;
}

export const ThemeContext = createContext("");

const ThemeUsage = ({ children }: ThemeUsageProps) => {
  const location = useLocation();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const [themeName, setThemeName] = useState<ThemeName>(
    (sessionStorage.getItem("theme") || "default") as ThemeName,
  );

  const theme: Theme = useMemo(
    () => THEMES[themeName] || THEMES.default,
    [themeName],
  );

  useEffect(() => {
    const isDemoPage = location.pathname.includes(DEMO_ROUTES.DEMO);

    if (location.pathname === ROUTES.INTRODUCTION) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }

    if (isDemoPage) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }

    if (pathname.includes(SMART_CHARGING_ROUTES.START)) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }

    if (pathname.includes(SMART_CHARGING_ROUTES.ADD_EV_START)) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }

    if (pathname.includes(SITE_AUTHENTICATION_ROUTES.START)) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }

    if (pathname.includes(SELF_ONBOARDING_ROUTES.COMPATIBILITY)) {
      const item = (searchParams.get("theme") as ThemeName) || "lichtblick";
      sessionStorage.setItem("theme", item);
      setThemeName(item);
    }
  }, [location.pathname, pathname, searchParams]);

  return (
    <ThemeProvider theme={theme}>
      <ThemeContext.Provider value={themeName}>
        <CssBaseline />
        {children}
      </ThemeContext.Provider>
    </ThemeProvider>
  );
};

export default ThemeUsage;
